export default {
    winzApiUrl: 'https://ep-winz-api-dev-dxc9eed0bzerasec.a01.azurefd.net',
    clientId: 'f2d4fe5b-807b-4e53-8efb-d625e8b01c5f',
    authority:'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2, // Default to Warning level
};